class Tracking {
  constructor(options = {}) {
    this.isEnabled = options.isEnabled;
    this.ua = options.ua;
    if (this.isEnabled) {
      this.initGa()
    }

    this.currentTextEdited = 0;
  }

  initGa() {
    /* eslint-disable */
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    /* eslint-enable */

    window.ga('create', this.ua, 'auto');
    window.ga('send', 'pageview');

    this.ga = window.ga;
  }

  fireEvent(event = {}) {
    if (!event || !this.isEnabled) {
      console.log(event);
      return;
    }

    const { category, action, label, value } = event;
    this.ga('send', 'event', category, action, label, value || 0);
  }

  textFocused() {
    this.currentTextEdited = 0;
  }

  textBlur(textField = '') {
    this.fireEvent({
      category: 'editor',
      action: 'text edited',
      label: textField,
      value: this.currentTextEdited,
    });

    this.currentTextEdited = 0;
  }

  videoPlay(videoName) {
    this.fireEvent({
      category: 'video',
      action: 'play',
      label: videoName,
    });
  }

  getVideoClick(videoName) {
    this.fireEvent({
      category: 'video',
      action: 'get click',
      label: videoName,
    });
  }

  downloadVideoClick(videoName) {
    this.fireEvent({
      category: 'video',
      action: 'download click',
      label: videoName,
    });
  }

  textEdited() {
    this.currentTextEdited += 1;
  }

  changeLogo() {
    this.fireEvent({
      category: 'editor',
      action: 'image changed',
      label: 'logo',
    });
  }

  changeScreenshot() {
    this.fireEvent({
      category: 'editor',
      action: 'image changed',
      label: 'screenshot',
    });
  }
}

export default Tracking;



// WEBPACK FOOTER //
// ./src/Tracking.js